<template>
  <div class="main-content">
    <Header />
    <div class="side-nav">
      <Sidebar :item="item" />
    </div>
    <div class="content">
      <div class="contact">
        <section id="feature1" class="section feature feature-center bg-white">
          <div class="container">
            <div class="row">
              <div class="col-12 col-md-12 col-lg-6 offset-lg-3" id="calendar">
                <div
                  class="calendly-inline-widget"
                  data-url="https://calendly.com/hrdesk/lets-talk"
                  style="min-width: 320px; height: 630px"
                ></div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "../partials/header";
import Sidebar from "../partials/sidebar";

export default {
  name: "Contact",
  components: {
    Header,
    Sidebar,
  },
  data() {
    return {
      item: "contact",
    };
  },
  mounted() {
    const calendly = document.createElement("script");
    calendly.setAttribute(
      "src",
      "//assets.calendly.com/assets/external/widget.js"
    );
    document.getElementById("calendar").appendChild(calendly);
  },
};
</script>
<style lang="scss" scoped>
.contact {
  padding: 2rem;
  @media (max-width: 768px) {
    padding: 0;
  }
}
.main-content {
  display: flex;
  max-width: 2000px;
  margin: 0 auto;

 .side-nav {
    width: 10rem;
    position: fixed;
    top: 2rem;
    left: 0;
    bottom: 0;
    background-color: #fff;
    margin-top: 4rem;

    ul {
      list-style: none;
      padding: 0;

      li {
        margin-bottom: 10px;
        cursor: pointer;
      }
    }

    @media (max-width: 768px) {
      display: none;
    }
  }

  .content {
   margin-top: 2rem;
    background: #fbfafa;
    margin-left: 200px;
    height: 100vh;

    @media (max-width: 768px) {
      margin-left: 0;
      padding: 1rem;
    }
  }

  @media (max-width: 768px) {
    .main-content {
      flex-direction: column;
      padding: 0;
    }
  }
}
</style>
